export default () => ({
  name: "",
  locations: [],
  vendor: null,
  secondaryLocations: [],
  secondaryVendor: null
});
